import { ITemplatesModel } from './model';

export default (self: ITemplatesModel) => ({
  get blue() {
    return self.toArray.find(({ isBlue }) => isBlue);
  },
  get aqms() {
    return self.toArray.find(({ isAqms }) => isAqms);
  }
});
